import { Navigate, RouteObject } from 'react-router-dom';
import { Roles } from '@/core/types';
import RolesGuard from '@/router/guards/RolesGuard';
import SitesPage from '@/views/pages/sites/index';
import SiteDevices from '@/views/pages/sites/site/devices';
import SitePage from '@/views/pages/sites/site/index';
import UsersPage from '@/views/pages/sites/site/users/Users';
import LocationsPage from '@/views/pages/sites/site/locations/index';
import LocationPage from '@/views/pages/sites/site/locations/location';

// Page available for Account Manager and Site Admin roles
export default [
	{
		path: 'sites',
		element: <RolesGuard roles={[Roles.ACCOUNT_ADMIN, Roles.SITE_ADMIN]} element={<SitesPage />} />,
	},
	{
		path: 'sites/:siteId',
		element: <RolesGuard roles={[Roles.ACCOUNT_ADMIN, Roles.SITE_ADMIN]} element={<SitePage />} />,
		children: [
			{
				path: '',
				element: <Navigate to="locations" replace={true} />,
			},
			{
				index: true,
				path: 'locations',
				element: <LocationsPage />,
			},
			{
				path: 'devices',
				element: <SiteDevices />,
			},
			{
				path: 'users',
				element: <UsersPage />,
			},
		],
	},
	{
		path: 'sites/:siteId/locations/:locationId',
		element: (
			<RolesGuard roles={[Roles.ACCOUNT_ADMIN, Roles.SITE_ADMIN]} element={<LocationPage />} />
		),
	},
] as RouteObject[];
